import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.scss'

const LoadingBar = ({ show }) => (<div className={`${styles.bar} ${show ? '' : styles.off}`} />)

LoadingBar.propTypes = {
  show: PropTypes.bool,
}

LoadingBar.defaultProps = {
  show: false,
}

export default LoadingBar



// WEBPACK FOOTER //
// ./components/LoadingBar/index.jsx